import { cloneDeep, get, isEqual, unset } from 'lodash';
import TIPS from '../../config/tips.json';

export default function getTipsForCurrentParameters(parametersSource, gameSlug = null) {
    const IF_CHOSEN_KEY_PARAMETER_IGNORE_VALUE_PARAMETERS_MAP = {
        'extraOperations.abCrossAc': ['extraOperations.mirror', 'extraOperations.rule101'],
        'extraOperations.mirror.isChosen': ['extraOperations.abCrossAc', 'extraOperations.rule101'],
        'extraOperations.rule101.isChosen': ['extraOperations.mirror', 'extraOperations.abCrossAc'],
    };
    const removeIgnoredParameters = parameters => {
        for (const [keyParameter, valueParameters] of Object.entries(
            IF_CHOSEN_KEY_PARAMETER_IGNORE_VALUE_PARAMETERS_MAP
        )) {
            if (get(parameters, keyParameter)) {
                valueParameters.forEach(parameterPath => {
                    unset(parameters, parameterPath);
                });
            }
        }
        return parameters;
    };

    let slug;
    if(gameSlug != null && !parametersSource?.slug){
        slug = gameSlug;
    } else {
        slug = parametersSource?.slug
    }
    const clonedTips = cloneDeep(TIPS[slug]) ?? [];

    return clonedTips.filter(tip => {
        let extraOperationHasToBeIgnored = false;
        const comparedParameters = Object.keys(tip.parameters);
        let gameComparedParameters = {};
        comparedParameters.forEach(parameter => {
            if (tip.parameters[parameter].multipleOptionsAllowed) {
                tip.parameters[parameter] = tip.parameters[parameter].options.find(parameterOption => {
                    if (parameter === 'extraOperations' && Object.keys(parameterOption).includes('mirror')) {
                        return isEqual(parameterOption.mirror, parametersSource[parameter].mirror);
                    }
                    return isEqual(parameterOption, parametersSource[parameter]);
                });
            }
            gameComparedParameters[parameter] = cloneDeep(parametersSource[parameter]);

            if (tip.withoutExtraOperations) {
                if (
                    parametersSource['extraOperations']['mirror']['isChosen'] ||
                    parametersSource['extraOperations']['abCrossAc']
                ) {
                    extraOperationHasToBeIgnored = true;
                }
            }
        });
        gameComparedParameters = removeIgnoredParameters(gameComparedParameters);
        return isEqual(tip.parameters, gameComparedParameters) && !extraOperationHasToBeIgnored;
    });
}
